import { render, staticRenderFns } from "./SearchCategorySingleDesktop.vue?vue&type=template&id=a84ce8ca&"
import script from "./SearchCategorySingleDesktop.vue?vue&type=script&lang=js&"
export * from "./SearchCategorySingleDesktop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports